/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-01-21 15:13:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-07 10:16:03
 * @FilePath: /code/zeelool-nextjs/src/theme/muiTheme.ts
 * @Description: Z站主题配置
 */
'use client';
import { env } from '@/utils/env';
import { createTheme } from '@mui/material/styles';
import { colors, font } from './zeelool.theme';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    '2xl': true;
    '3xl': true;
    '4xl': true;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      '2xl': 1536,
      '3xl': 1920,
      '4xl': 2560,
    },
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: colors.primaryPurple, // 主题色-蓝色  2025 颜色规范
        },
        black: {
          // 主题色 - 黑色 2025 颜色规范
          main: colors.primaryBlack,
          contrastText: colors.primaryWhite,
        },
        green: {
          // 主题色 - 绿色 2025 颜色规范
          main: colors.primaryGreen,
          contrastText: colors.primaryBlack,
        },
        // TODO: 暂时在这里，后续不会有这个主色，它只是作为辅助色使用，之后删除掉
        orange: {
          main: colors.auxiliaryOrange, // 主题色 - 橙色 2025 颜色规范
          contrastText: colors.primaryWhite,
        },
        secondary: {
          main: colors.auxiliaryLilacPurple, // 辅助色-紫丁香 - 2025 颜色规范
        },

        error: {
          main: colors.error, // 错误颜色 - 2025 颜色规范
        },
        warning: {
          main: colors.warning, // 告警颜色 - 2025 颜色规范
        },
        success: {
          main: colors.success, // 成功颜色 - 2025 颜色规范
        },
        divider: '#d8d8d8', // 这个分割线的颜色会影响Tab组件的，暂时先定义d8d8d8
        text: {
          primary: colors.primaryText, // 主要文字- 2025 颜色规范
          secondary: colors.auxiliaryText, // 次要文字- 2025 颜色规范
          // disabled: colors.secondaryText, // TODO:禁用的颜色定义？
        },
        // action的配置暂时用不到，先不做配置了
        background: {
          default: '#fffff',
          paper: '#ffffff',
        },
      },
    },
  },
  cssVariables: {
    colorSchemeSelector: 'class',
    cssVarPrefix: 'zeelool',
  },
  typography: {
    fontFamily: 'var(--font-bricolage)',
  },
  zIndex: {
    tooltip: 100, // 使用默认层级；具体覆盖通过组件传参 zIndex 处理
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true, // 全局禁用水波纹效果
      },
      styleOverrides: {
        root: {
          '&.MuiIconButton-root:hover': {
            backgroundColor: 'transparent',
          },
          '&.Mui-disabled': {
            pointerEvents: 'auto',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            '& .MuiInputBase-input': {
              cursor: 'not-allowed',
            },
          },
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          '& .MuiPaginationItem-page': {
            color: '#282828',
            backgroundColor: '#F4F4F4',
            '&:hover': {
              backgroundColor: `${colors.primaryPurple}1A`, // 10% opacity
              color: '#282828',
            },
            '&.Mui-selected': {
              backgroundColor: colors.primaryPurple,
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: colors.primaryPurple,
                color: '#FFFFFF',
              },
            },
            '&.Mui-disabled': {
              backgroundColor: '#F4F4F466', // 40% opacity
              color: '#282828',
            },
          },
          '& .MuiPaginationItem-previousNext': {
            backgroundColor: '#FFFFFF',
            margin: '0 14px 0 !important',
            '&:hover': {
              backgroundColor: '#F4F4F4',
            },
            '&.Mui-disabled': {
              color: '#F4F4F466', // 40% opacity
            },
          },
        },
      },
    },
    MuiRadio: {
      defaultProps: {
        disableRipple: true, // 全局禁用水波纹效果
      },
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true, // 全局禁用水波纹效果
      },
      styleOverrides: {
        root: {
          borderRadius: '3px',
          '&.MuiCheckbox-colorPrimary': {
            color: '#d4d4d4',
            '&:hover': {
              color: colors.auxiliaryDarkGray,
            },
            '&.Mui-checked, &.Mui-indeterminate': {
              color: colors.primaryPurple,
              '&:hover': {
                color: colors.primaryPurple, // 保持选中态颜色不变
              },
            },
            '&.Mui-disabled': {
              color: '#d4d4d4',
              '&.Mui-checked, &.Mui-indeterminate': {
                color: colors.primaryPurple,
                opacity: 0.4,
                backgroundColor: 'transparent',
              },
            },
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 'auto',
        },
        indicator: {
          height: '2px',
          backgroundColor: colors.primaryBlack,
        },
        flexContainer: ({ theme: muiTheme2 }) => ({
          gap: '20px',
          [`@media (min-width: ${muiTheme2.breakpoints.values.lg}px)`]: {
            gap: '56px',
          },
        }),
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true, // 禁用水波纹效果
      },
      styleOverrides: {
        root: ({ theme: muiTheme2 }) => ({
          padding: '12px 0px',
          minHeight: 'auto',
          minWidth: 'auto',
          textTransform: 'none',
          fontSize: '14px',

          fontFamily: font.br,
          color: colors.primaryBlack,
          opacity: 1,
          '&:hover': {
            backgroundColor: 'transparent',
            color: colors.primaryBlack,
          },
          '&.Mui-selected': {
            color: colors.primaryBlack,
            fontFamily: font.bb,
          },
          '&.Mui-disabled': {
            color: '#d4d4d4',
          },
          // Badge样式
          '& .MuiBadge-badge': {
            backgroundColor: colors.primaryPurple,
            color: colors.primaryWhite,
            fontWeight: 'bold',
            fontSize: '12px',
            minWidth: '20px',
            height: '20px',
            padding: '0 6px',
            borderRadius: '10px',
          },
          [`@media (min-width: ${muiTheme2.breakpoints.values.lg}px)`]: {
            fontSize: '20px',
          },
        }),
      },
    },

    MuiAlert: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { severity: 'info' },
              style: {
                backgroundColor: '#60a5fa',
              },
            },
          ],
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px', // 默认圆角
          fontFamily: 'var(--font-bricolage)',
          textTransform: 'none', // 禁用转换
          variants: [
            // Primary 按钮 (蓝色)
            {
              props: { variant: 'contained', color: 'primary' },
              style: {
                backgroundColor: colors.primaryPurple,
                color: colors.primaryWhite,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: colors.primaryPurpleHover,
                  boxShadow: 'none',
                },
                '&:active': {
                  backgroundColor: colors.primaryPurpleActive,
                },
                '&.Mui-disabled': {
                  backgroundColor: colors.primaryPurpleDisable,
                },
                '&.MuiButton-loading': {
                  color: colors.primaryWhite,
                },
              },
            },
            // Black 按钮
            {
              props: { variant: 'contained', color: 'dark' },
              style: {
                backgroundColor: colors.primaryBlack,
                color: colors.primaryWhite,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: colors.primaryBlackHover,
                  boxShadow: 'none',
                },
                '&:active': {
                  backgroundColor: colors.primaryBlackActive,
                },
                '&.Mui-disabled': {
                  backgroundColor: colors.primaryBlackDisable,
                },
              },
            },
            // Green 按钮
            {
              props: { variant: 'contained', color: 'green' },
              style: {
                backgroundColor: colors.primaryGreen,
                color: colors.primaryWhite,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: colors.primaryGreenHover,
                  boxShadow: 'none',
                },
                '&:active': {
                  backgroundColor: colors.primaryGreenActive,
                },
                '&.Mui-disabled': {
                  backgroundColor: colors.primaryGreenDisable,
                },
              },
            },
            // white 按钮
            {
              props: { variant: 'contained', color: 'light' },
              style: {
                backgroundColor: colors.primaryWhite,
                color: colors.primaryBlack,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: colors.primaryWhiteHover,
                  boxShadow: 'none',
                },
                '&:active': {
                  backgroundColor: colors.primaryWhiteActive,
                },
                '&.Mui-disabled': {
                  backgroundColor: colors.primaryWhiteDisable,
                },
              },
            },
            // white & outlined 按钮
            {
              props: { variant: 'outlined', color: 'purple' },
              style: {
                backgroundColor: colors.primaryWhite,
                color: colors.primaryPurple,
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: colors.auxiliaryDarkGray,
                  opacity: 0.05,
                },
                '&:active': {
                  backgroundColor: colors.auxiliaryDarkGray,
                  opacity: 0.08,
                },
                '&.Mui-disabled': {
                  opacity: 0.04,
                },
              },
            },
            // Default outlined 按钮 - 修复默认的半透明边框问题
            {
              props: { variant: 'outlined', color: 'primary' },
              style: {
                borderColor: colors.auxiliaryDarkGray, // 使用实心边框颜色而不是默认的半透明蓝色
                color: colors.primaryBlack,
                '&:hover': {
                  borderColor: colors.primaryBlack,
                },
                '&:focus': {
                  borderColor: colors.primaryBlack,
                },
              },
            },
          ],
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          // 内置margin8px，这样label在顶部的时候不至于被截断
          margin: '8px 0 0 0',
          // 确保helperText的间距一致
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginTop: '4px',
          },
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            '& .MuiOutlinedInput-input': {
              cursor: 'not-allowed',
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          height: '50px',
          backgroundColor: '#ffffff',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.auxiliaryDarkGray,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primaryBlack,
            borderWidth: '1px',
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.error,
          },
          '&.Mui-disabled': {
            backgroundColor: '#eee',
            cursor: 'not-allowed',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d4d4d4',
            },
            '& .MuiOutlinedInput-input': {
              cursor: 'not-allowed',
            },
          },
          '&.MuiInputBase-sizeSmall': {
            height: '50px',
            '& .MuiOutlinedInput-input': {
              padding: '0 16px',
              height: '50px',
              lineHeight: '50px',
            },
          },
          '@media (max-width: 600px)': {
            height: '46px',
            '&.MuiInputBase-sizeSmall': {
              height: '46px',
              '& .MuiOutlinedInput-input': {
                height: '46px',
                lineHeight: '46px',
              },
            },
          },
          '&.no-label .MuiOutlinedInput-notchedOutline': {
            legend: {
              display: 'none',
            },
          },
          '&.no-label:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primaryBlack,
          },
        },
        notchedOutline: {
          borderColor: '#d4d4d4',
          top: '-5px',
        },
        input: {
          padding: '0 16px',
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
          '&::placeholder': {
            color: colors.auxiliaryText,
            opacity: 1,
          },
          '@media (max-width: 600px)': {
            height: '46px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: colors.auxiliaryText,
          transform: 'translate(16px, 14px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(16px, -9px) scale(0.75)',
          },
          '&.Mui-focused': {
            color: colors.primaryBlack,
          },
          '&.Mui-error': {
            color: colors.auxiliaryText,
          },
          '&.Mui-disabled': {
            color: colors.secondaryText,
          },
          '& .MuiFormLabel-asterisk.Mui-error': {
            color: colors.auxiliaryText,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '& .MuiFormLabel-root.MuiInputLabel-root': {
            lineHeight: '1.4em',
          },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          fontSize: '12px',
          '&.Mui-error': {
            color: colors.error,
          },
        },
      },
    },

    // Select组件样式
    MuiSelect: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
      },
      styleOverrides: {
        select: {
          display: 'flex',
          alignItems: 'center',
          padding: '0 16px',
          height: '50px',
          '&.MuiInputBase-input': {
            minHeight: '50px',
            // 左右保持16px，因为在处方表单中用到该组件，需要居中，如果有其他地方
            // 影响到的话，覆盖掉该属性
            ...(env.NEXT_PUBLIC_SITE_NAME !== 'fr' && {
              padding: '0 16px 0 16px',
            }),
          },
          '&.Mui-disabled': {
            backgroundColor: '#F4F4F4',
            cursor: 'not-allowed',
          },
          '@media (max-width: 600px)': {
            height: '46px',
            '&.MuiInputBase-input': {
              minHeight: '46px',
            },
          },
        },
        icon: {
          right: '16px',
          color: colors.primaryBlack,
          fontSize: '16px',
        },
      },
    },

    // 下拉菜单样式
    MuiMenu: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        slotProps: {
          paper: {
            elevation: 8,
          },
        },
      },
      styleOverrides: {
        paper: {
          marginTop: '8px',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          borderRadius: '4px',
          maxHeight: '300px',
          padding: '0 8px',
        },
        list: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },

    // 菜单项样式
    MuiMenuItem: {
      styleOverrides: {
        root: {
          minHeight: '50px',
          padding: '10px 12px',
          backgroundColor: '#ffffff',
          '@media (max-width: 600px)': {
            minHeight: '46px',
          },
          '&.Mui-selected': {
            color: colors.primaryPurple,
            backgroundColor: '#ffffff',
            borderRadius: '6px',
            '&.Mui-focusVisible': {
              // backgroundColor: colors.auxiliaryLightPurple,
              borderRadius: '6px',
            },
            '&:hover': {
              backgroundColor: colors.auxiliaryLightPurple,
              borderRadius: '6px',
            },
          },
          '&:hover': {
            backgroundColor: colors.auxiliaryLightPurple,
            borderRadius: '6px',
          },
        },
      },
    },

    // 自动完成组件样式
    MuiAutocomplete: {
      defaultProps: {
        slotProps: {
          paper: {
            elevation: 8,
          },
        },
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            // paddingRight: '14px',
          },
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            '& .MuiOutlinedInput-root': {
              cursor: 'not-allowed',
            },
            '& .MuiOutlinedInput-input': {
              cursor: 'not-allowed',
            },
          },
        },
        paper: {
          marginTop: '8px',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          borderRadius: '4px',
          padding: '0 8px',
        },
        listbox: {
          padding: '0',
          '& .MuiAutocomplete-option': {
            // TODO: 这里的样式和AutoComplete组件中的样式有冲突，需要统一
            minHeight: '48px',
            padding: '10px 12px',
            '&[aria-selected="true"]': {
              color: colors.primaryPurple,
              backgroundColor: '#ffffff',
              '&.Mui-focused': {
                backgroundColor: colors.auxiliaryLightPurple,
                borderRadius: '6px',
              },
            },
            '&.Mui-focused': {
              backgroundColor: colors.auxiliaryLightPurple,
              borderRadius: '6px',
            },
          },
        },
        popupIndicator: {
          transform: 'none',
          '&.MuiAutocomplete-popupIndicatorOpen': {
            transform: 'rotate(180deg)',
          },
          padding: '4px',
          top: 'calc(50% - 12px)',
        },
        endAdornment: {
          top: '50%',
          right: '8px',
          position: 'absolute',
        },
      },
    },

    // 日期选择器样式 - 这些样式会在DatePicker组件中通过props传递
    // MuiPickersDay组件样式可以通过components prop定制

    // Dialog 组件样式
    MuiDialog: {
      styleOverrides: {
        root: {
          touchAction: 'none',
        },
        paper: ({ theme: muiTheme }) => ({
          borderRadius: '16px', // 移动端默认使用 16px 圆角
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
          width: '100%',
          maxWidth: '480px', // 默认最大宽度
          maxHeight: 'unset', // MUI原来设置了最大高度，取消掉
          margin: '16px',
          [`@media (min-width: ${muiTheme.breakpoints.values.xl}px)`]: {
            borderRadius: '12px', // xl 屏幕尺寸以上使用 12px 圆角
          },
        }),
        // 弹窗内容区域样式
        paperWidthSm: {
          maxWidth: '320px', // 小尺寸弹窗最大宽度
        },
        paperWidthMd: {
          maxWidth: '460px', // 中尺寸弹窗最大宽度
        },
        paperWidthLg: {
          maxWidth: '628px', // 大尺寸弹窗最大宽度
        },
      },
    },

    // Dialog 标题样式
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme: muiTheme2 }) => ({
          padding: '28px 40px 20px 40px', // 顶部28px，左右40px，底部20px
          fontSize: '16px',
          fontFamily: font.be,
          lineHeight: '22px',
          textAlign: 'center',
          position: 'relative',
          color: colors.primaryBlack,
          [`@media (min-width: ${muiTheme2.breakpoints.values.xl}px)`]: {
            padding: '24px 40px 24px 40px',
          },
        }),
      },
    },

    // Dialog 内容样式
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme: muiTheme3 }) => ({
          padding: '0 20px 32px 20px', // 左右40px，底部32px
          fontSize: '14px',
          lineHeight: '20px',
          color: colors.primaryBlack,
          maxHeight: '85vh',
          overflow: 'auto',
          [`@media (min-width: ${muiTheme3.breakpoints.values.xl}px)`]: {
            padding: '10px 24px 32px',
          },
        }),
      },
    },

    // Dialog 操作区域样式
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme: muiTheme4 }) => ({
          padding: '0 20px 32px 20px', // 左右40px，底部32px
          justifyContent: 'center',
          gap: '12px', // 按钮之间的间距
          [`@media (min-width: ${muiTheme4.breakpoints.values.xl}px)`]: {
            padding: '0 32px 24px 32px', // 左右40px，底部32px
          },
        }),
      },
    },

    // Tooltip 组件样式
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff',
          color: colors.primaryBlack,
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          fontSize: '14px',
          padding: '8px 12px',
          borderRadius: '4px',
        },
        arrow: {
          color: '#fff',
        },
      },
    },
  },
});

export default theme;
